module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-4.a76c6d3d.svg";